<template>
  <framed-layout>
    <template #left>
      <!--<router-link href="/" class="btn-circle">-->
      <!--  <i class="text-xl text-blue-500 pi pi-chevron-left"></i>-->
      <!--</router-link>-->
    </template>

    <template #center>
      <h3 class="font-bold">Palun lisa enda e-mail ja telefoninumber</h3>
    </template>

    <template #right>
      <!--<router-link href="/" class="btn-circle">-->
      <!--  <i class="text-xl text-blue-500 pi pi-times"></i>-->
      <!--</router-link>-->
    </template>

    <div class="max-w-md mx-auto">
      <div class="flex space-x-6 py-4">
        <div class="flex-1 p-float-label">
          <input-text
              required
              id="email"
              type="email"
              placeholder=" "
              v-model="email"
              :use-grouping="false"
              :class="{ 'p-invalid': invalid }"
              class="w-full"
          />
          <label for="email">E-mail</label>
        </div>
      </div>

      <div class="flex space-x-6 py-4">
        <input-mask id="phone-code" v-model="phoneCode" mask="+***" prefix="+" class="w-20" />

        <div class="flex-1 p-float-label">
          <input-text
              id="phone"
              placeholder=" "
              v-model="phone"
              :use-grouping="false"
              class="w-full"
          />
          <label for="phone">Telefoni number</label>
        </div>
      </div>
    </div>

    <div class="my-12 text-center">
      <button class="w-56 text-white bg-orange-400 btn" @click="submit">Jätka</button>
    </div>

  </framed-layout>
</template>

<script>
import FramedLayout from './../Layouts/FramedLayout'
import validEmail from './../utils/validEmail'
import {updateContactInfo} from "@/store/user.api";

export default {
  props: ['errors'],
  components: {
    FramedLayout
  },
  data() {
    return {
      projectId: null,
      invalid: false,
      phoneCode: 372,
      email: null,
      phone: null
    }
  },
  methods: {
    async submit() {
      if (!validEmail(this.email)) {
        this.invalid = true
      } else {
        this.invalid = false

        if (this.phone !== null
            && (this.phoneCode === null
                || this.phoneCode === undefined
                || this.phoneCode === '')) {
          this.phoneCode = 372;
        }

        if (this.phoneCode.startsWith('+')) {
          this.phoneCode = this.phoneCode.substring(1);
        }

        const params = {
          email: this.email,
          phoneCode: this.phoneCode,
          phone: this.phone
        };
        updateContactInfo(params).then(({ data }) => {
          setTimeout(() => {
            this.processAxiosPositiveResponse(data);
          }, 100);
          this.$store.dispatch('global/getUser');
          this.$router.push('/projects');
        },(error) => {
          this.invalid = true
          const toast = error.response?.data;
          if (toast) {
            this.processAxiosPositiveResponse(toast);
          }
        });
      }
    }
  },
  mounted() {
    this.projectId = this.$route.query?.projectId;
  }
}
</script>
